import React, { useEffect, useState } from "react";
import "./PerfilModal.css";
import { getPerfil, updatePerfil } from "../../../services/perfilservice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

export default function PerfilModal({ open, onClose }) {
  const [form, setForm] = useState({
    nombre: "",
    apellido: "",
    telefono: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      cargarPerfil();
    }
  }, [open]);

  const cargarPerfil = async () => {
    const data = await getPerfil();
    if (data) {
      setForm({
        nombre: data.nombre || "",
        apellido: data.apellido || "",
        telefono: data.telefono || "",
        email: data.email || "",
      });
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Validación
  const validarFormulario = () => {
    // Nombre
    if (!form.nombre.trim()) {
      toast.error("El nombre es obligatorio");
      return false;
    }

    // Apellido
    if (!form.apellido.trim()) {
      toast.error("El apellido es obligatorio");
      return false;
    }

    // Email
    if (!form.email.trim()) {
      toast.error("El email es obligatorio");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      toast.error("El email no tiene un formato válido");
      return false;
    }

    // Teléfono (opcional, pero si se llena debe ser válido)
    if (form.telefono.trim()) {
      const telefonoRegex = /^[0-9]{7,15}$/;
      if (!telefonoRegex.test(form.telefono)) {
        toast.error("El teléfono debe ser solo números (7 a 15 dígitos)");
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // validar antes de enviar
    if (!validarFormulario()) return;

    setLoading(true);

    const res = await updatePerfil(form);
    setLoading(false);

    if (res && res.res === 1) {
      toast.success(res.mensaje);
      onClose();
    } else {
      toast.error(res.mensaje || "Error al actualizar");
    }
  };

  if (!open) return null;

  return (
    <div className="modalOverlay">
      <div className="modalCard">
        <h2>Mi Perfil</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="formGroup">
              <label>Nombre</label>
              <input
                name="nombre"
                value={form.nombre}
                onChange={handleChange}
                required
              />
            </div>

            <div className="formGroup">
              <label>Apellido</label>
              <input
                name="apellido"
                value={form.apellido}
                onChange={handleChange}
                required
              />
            </div>

            <div className="formGroup">
              <label>Teléfono</label>
              <input
                name="telefono"
                value={form.telefono}
                onChange={handleChange}
              />
            </div>

            <div className="formGroup">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="modalActions">
            <button type="button" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" disabled={loading} className="btn-save">
              <FontAwesomeIcon icon={faSave} />
              {loading ? "Guardando..." : "Guardar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
